/** Контент лендинга `/use-cases/stream-timer` (вёрстка — `UseCasePageLayout`). */

import type { UseCasePageContent } from './useCasePageContent';

export const STREAM_TIMER_CONTENT: UseCasePageContent = {
  heroEyebrow: 'СТРИМЫ, ТРАНСЛЯЦИИ, КИБЕРСПОРТ',
  heroLead:
    'Держите тайминг стримов на Twitch и YouTube, трансляций и игровых турниров. Таймер с удалённым управлением: добавьте экран в OBS и управляйте отсчётом с телефона, не выходя из игры.',
  heroNote: 'Без регистрации. Работает в браузере.',

  scenarios: {
    title: 'Где пригодится',
    lead:
      'preztimer держит тайминг там, где эфир идёт по сегментам, а пауза или перерасход сразу видны зрителям.',
    items: [
      {
        title: 'Соло-стримы',
        text: 'Таймер сегмента или паузы в углу эфира — управляйте с телефона, не отрываясь от игры.',
      },
      {
        title: 'Киберспорт и турниры',
        text: 'Таймеры матчей и перерывов, общий тайминг для продакшн-команды на разных позициях.',
      },
      {
        title: 'Подкасты и совместные эфиры',
        text: 'Равное время гостям и сигналы со-ведущим — без голосовых команд в эфире.',
      },
    ],
  },

  share: {
    title: 'Добавьте таймер в OBS за пару минут',
    paragraphs: [
      'Экран таймера — это веб-страница. Добавьте её в OBS как Browser Source или выведите через демонстрацию экрана. Отсчётом управляйте с телефона, планшета или второго монитора.',
      'Та же ссылка работает для со-ведущих: откройте экран таймера на нескольких устройствах — состояние синхронно. Установка и регистрация не нужны, можно начать с гостевой комнаты.',
    ],
  },

  cloud: {
    title: 'Управляйте таймером, не отрываясь от эфира',
    lead:
      'Контролируйте отсчёт с любого устройства, не сворачивая игру. Подходит и соло-стримерам, и продакшн-командам.',
    bullets: [
      'старт эфира по предварительному отсчёту;',
      'таймеры сегментов: гайд, геймплей, общение с чатом;',
      'таймеры перерывов с показом перерасхода после нуля.',
    ],
  },

  communication: {
    title: 'Сообщения и сигналы в реальном времени',
    lead:
      'Координируйте эфир короткими сообщениями, а цветовые зоны подскажут, когда сегмент подходит к концу.',
    bullets: [
      'короткие сообщения со-ведущим и в кадр;',
      'цветовые зоны при приближении к нулю;',
      'быстрые кнопки добавляют или убавляют время в эфире.',
    ],
  },

  modes: {
    title: 'Один таймер для всех площадок',
    lead:
      'Один и тот же экран таймера подходит для Twitch, YouTube и других площадок — это просто ссылка.',
    bullets: [
      'обратный отсчёт, секундомер или часы (время суток);',
      'ссылка и QR-код для со-ведущих, синхронно на всех устройствах;',
      'отдельная комната на каждый эфир или сцену турнира.',
    ],
  },

  pricing: {
    title: 'Цены',
    lead:
      'Для соло-стримеров базовых функций хватит — бесплатно. Профи добавляет больше таймеров, комнат и подключений.',
  },

  crossLink: {
    title: 'Связанный сценарий: продакшн-команды',
    lead:
      'Шоу, многокамерные трансляции и несколько сцен — отдельная страница с акцентом на работу всей продакшн-команды.',
    to: '/use-cases/timer-event-production',
    linkLabel: 'Таймер для продакшн-команд',
  },

  faqSectionTitle: 'Частые вопросы о таймере для стрима',
  faqItems: [
    {
      question: 'Как добавить таймер на стрим в OBS?',
      answer:
        'Создайте таймер в preztimer и откройте экран таймера по ссылке. В OBS добавьте источник Browser Source и укажите эту ссылку — отсчёт появится в эфире. Управлять таймером можно с телефона или другого устройства, не сворачивая игру.',
    },
    {
      question: 'Работает ли с OBS и другим стрим-софтом?',
      answer:
        'Да. Экран таймера — обычная веб-страница, поэтому подходит как Browser Source в OBS и любом софте с поддержкой браузерных источников. Как альтернатива — показ экрана через демонстрацию.',
    },
    {
      question: 'Как управлять таймером во время игры?',
      answer:
        'Откройте панель управления по ссылке на телефоне, планшете или втором мониторе. Запускайте, ставьте на паузу, переключайте таймеры и добавляйте время, не отрываясь от эфира.',
    },
    {
      question: 'Бесплатно ли для небольших стримеров?',
      answer:
        'Да. Базовых функций тайминга достаточно для соло-стрима — это бесплатно, до 3 одновременных подключений. Для команды и больших лимитов есть лицензия Профи.',
    },
    {
      question: 'Подходит ли для турниров и киберспорта?',
      answer:
        'Да. Создайте таймеры матчей и перерывов, а для разных сцен — отдельные комнаты. Переключение между таймерами и переход к следующему матчу выполняются вручную.',
    },
    {
      question: 'Можно ли собирать вопросы зрителей или включить аудио-сигналы?',
      answer:
        'Нет. Сбора вопросов от зрителей и звуковых сигналов сейчас нет. Для координации в эфире используйте короткие сообщения на экране таймера и цветовые зоны.',
    },
  ],
};
